import { Box, Card, IconButton, Tooltip } from '@mui/material';
import { StyledSectionHeading } from '../../../../../components/inputs/InputLabel';
import { LocalizedRichTextField } from '../../../../../components/inputs/LocalizedRichTextField';
import { StyledQuestionMark } from '../../../../../components/QuestionMark';

type DescriptionSectionProps = {
  description: Record<string, string>;
  locales: string[];
  disabled?: boolean;
  onChange: (value: Record<string, string>) => void;
};

export const DescriptionSection = ({
  description,
  locales,
  disabled = false,
  onChange,
}: DescriptionSectionProps) => {
  return (
    <>
      <LocalizedRichTextField
        id="description"
        label={
          <>
            Agreement description
            <Tooltip
              title="Agreement description text shown to researchers on the public search page when clicking on the payment icon."
              placement="top"
            >
              <IconButton
                size="small"
                sx={{ marginLeft: '3px' }}
                aria-label="Agreement description text shown to researchers on the public search page when clicking on the payment icon."
              >
                <StyledQuestionMark fontSize="small" />
              </IconButton>
            </Tooltip>
          </>
        }
        locales={locales}
        value={description}
        onChange={onChange}
        disabled={disabled}
        warnEmpty
      />
    </>
  );
};
